// extracted by mini-css-extract-plugin
export default {"notification-bar":"kuYzQ","additionalInfo":"i9p9w"};